export default function Dashboard() {
  return (
    <section>
      <h1>Dashboard</h1>
      <p>Welcome to Ocean Admin.</p>
    </section>
  );
}
